import { render, staticRenderFns } from "./ItemsComponent.vue?vue&type=template&id=af5c2942&scoped=true&"
import script from "./ItemsComponent.vue?vue&type=script&lang=js&"
export * from "./ItemsComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af5c2942",
  null
  
)

export default component.exports